import { render, staticRenderFns } from "./InventoryData.vue?vue&type=template&id=0230bc05&scoped=true"
import script from "./InventoryData.vue?vue&type=script&lang=js"
export * from "./InventoryData.vue?vue&type=script&lang=js"
import style0 from "./InventoryData.vue?vue&type=style&index=0&id=0230bc05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0230bc05",
  null
  
)

export default component.exports